<template>
    <div class="ts-finder__layout-mobile-infowindow">
        <station-info-window :station="selectedStation" :userLocation="userLocation" v-if="selectedStation" />
    </div>
</template>

<script>
    const clusterizeZoomLevelThreshold = 9;
    const mapPaddingDesktop = {
        top: 20,
        right: 20,
        bottom: 20,
        left: 390
    };

    const mapPaddingMobile = {
        top: 159,
        right: 20,
        bottom: 20,
        left: 20
    }

    const textarea = $('<textarea />');

    import Vue from 'vue'
    import { mapState, mapActions } from 'vuex'
    import StationInfoWindow from './StationInfoWindow.vue'
    import { MarkerClusterer, SuperClusterAlgorithm } from "@googlemaps/markerclusterer";
    import { MigrolClusterRenderer } from '../../utils/MigrolClusterRenderer';
    import * as R from 'ramda'
    import * as Utils from '../../utils/utils'
    import $ from 'jQuery'

    export default {
        props: {
            google: Object,
            map: Object
        },
        data() {
            return {
                markerCluster: null,
                infowindow: null,
                mobileInfowindowContainer: null,
                userLocationMarker: null
            };
        },
        computed: {
            ...mapState([
                'selectedStation',
                'allStations',
                'filteredStations',
                'userLocation',
                'selectedCantons',
                'supressFilterZoomingOnce'
            ])
        },
        watch: {
            selectedStation(station) {
                this.setActive(station);
            },
            filteredStations() {
                //filtered stations have changed, close infowindow and refresh markers
                if (this.infowindow != null) {
                    this.infowindow.destroy();
                    this.infowindow = null;
                }

                //refresh the markers
                this.refreshMarkers();

                if (this.supressFilterZoomingOnce === true) {
                    this.deactivateSupressFilterZoomingOnce();
                } else {
                    if (this.markerCluster != null) {
                        const markers = this.markerCluster.markers;

                        // new request Mirjam 22.06.2021: after every filter click, we want to fit whatever markers we can to the viewport
                        //if (markers.length > 0) {
                        //    let newBounds = new this.google.maps.LatLngBounds();
                        //    for (var i = 0; i < markers.length; i++) {
                        //        newBounds.extend(markers[i].getPosition());
                        //    }
                        //    this.map.fitBounds(newBounds, this.getMapPadding());

                        //    // this redraws the clusters as soon as the fitbounds animation is over, otherwise they will be messed up:
                        //    //https://github.com/googlemaps/v3-utility-library/issues/469
                        //    let me = this;
                        //    this.google.maps.event.addListenerOnce(this.map, 'idle', function () {
                        //        me.markerCluster.render();
                        //    });
                        //}
                        // 08.04.2022: Mirjam changed her mind based on the TS-UX Optimierungen document from Ergonomen...now this zoom to fit all shouldn't happen, but one station should still be visible
                        if (markers.length > 0) {
                            this.ensureAtLeastOneVisibleMarker();
                        }
                    }
                }
            },
            userLocation(newValue) {
                if (this.userLocationMarker != null) {
                    this.userLocationMarker.setMap(null); //remove existing userLocation marker
                    this.userLocationMarker = null;
                }

                if (newValue != null) {
                    const position = { lat: +newValue.latitude, lng: +newValue.longitude };
                    this.userLocationMarker = new this.google.maps.Marker({
                        position: position,
                        map: this.map
                    });
                    // zoom in to the psition
                    this.map.panTo(position);
                    this.map.setZoom(12);
                    this.ensureAtLeastOneVisibleMarker();
                }
            },
            selectedCantons() {
                if (this.markerCluster != null) {
                    //when selected cantons change, zoom and pan the map, so that all markers are visible
                    let bounds = new this.google.maps.LatLngBounds();
                    const markers = this.markerCluster.markers;
                    for (var i = 0; i < markers.length; i++) {
                        bounds.extend(markers[i].getPosition());
                    }
                    this.map.fitBounds(bounds, this.getMapPadding());

                    // this redraws the clusters as soon as the fitbounds animation is over, otherwise they will be messed up:
                    //https://github.com/googlemaps/v3-utility-library/issues/469
                    let me = this;
                    this.google.maps.event.addListenerOnce(this.map, 'idle', function () {
                        if (me.markerCluster != null)
                            me.markerCluster.render();
                    });
                }
            }
        },
        methods: {
            ...mapActions([
                'selectStation',
                'deactivateSupressFilterZoomingOnce'
            ]),
            getMapPadding() {
                return window.innerWidth < 900 ? mapPaddingMobile : mapPaddingDesktop;
            },
            getPaddedBounds() {
                var mapPadding = this.getMapPadding();
                var npad = mapPadding.top;
                var spad = mapPadding.bottom;
                var epad = mapPadding.right;
                var wpad = mapPadding.left;
                var SW = this.map.getBounds().getSouthWest();
                var NE = this.map.getBounds().getNorthEast();
                var topRight = this.map.getProjection().fromLatLngToPoint(NE);
                var bottomLeft = this.map.getProjection().fromLatLngToPoint(SW);
                var scale = Math.pow(2, this.map.getZoom());

                var SWtopoint = this.map.getProjection().fromLatLngToPoint(SW);
                var SWpoint = new this.google.maps.Point(((SWtopoint.x - bottomLeft.x) * scale) + wpad, ((SWtopoint.y - topRight.y) * scale) - spad);
                var SWworld = new this.google.maps.Point(SWpoint.x / scale + bottomLeft.x, SWpoint.y / scale + topRight.y);
                var pt1 = this.map.getProjection().fromPointToLatLng(SWworld);

                var NEtopoint = this.map.getProjection().fromLatLngToPoint(NE);
                var NEpoint = new this.google.maps.Point(((NEtopoint.x - bottomLeft.x) * scale) - epad, ((NEtopoint.y - topRight.y) * scale) + npad);
                var NEworld = new this.google.maps.Point(NEpoint.x / scale + bottomLeft.x, NEpoint.y / scale + topRight.y);
                var pt2 = this.map.getProjection().fromPointToLatLng(NEworld);

                return new this.google.maps.LatLngBounds(pt1, pt2);
            },
            setActive(station) {

                //if we have an existing infowindow, clean everything up first
                if (this.infowindow != null) {
                    var oldMarker = this.infowindow._marker;
                    if (oldMarker != null) {
                        oldMarker.setIcon(oldMarker.markerInactiveUrl);
                        oldMarker.setZIndex();
                    }
                    this.infowindow.destroy();
                    this.infowindow = null;
                }

                //if no station was selected (e.g. when a station was un-selected by closing the infowindow), simply return here
                if (!station) {
                    return;
                }

                //this creates a new instance of a StationInfoWindow and passes the current station as a property and then mounts it
                let StationInfoWindowComponent = Vue.extend(StationInfoWindow);
                let instance = new StationInfoWindowComponent({
                    parent: this,
                    propsData: {
                        station: station,
                        userLocation: this.userLocation
                    }
                });
                instance.$mount();

                //find the correct marker
                const marker = R.find(gMark => gMark.stationId === station.id)(this.markerCluster.markers);

                if (marker != null) {
                    //bring marker to front
                    marker.setZIndex(this.google.maps.Marker.MAX_ZINDEX + 1);

                    //set marker to selected
                    marker.setIcon(station.markerselectedurl);

                    if (this.map.getZoom() <= clusterizeZoomLevelThreshold) {
                        this.map.setZoom(clusterizeZoomLevelThreshold + 1);
                    }

                    this.map.panTo(marker.getPosition());

                    var that = this;

                    //now wait for the map to "idle" (meaning the pan/zoom animations have finished, before showing the infowindow, since it won't show otherwise)
                    this.google.maps.event.addListenerOnce(this.map, "idle", function () {

                        //create a new infowindow
                        that.infowindow = new window.SnazzyInfoWindow({
                            marker: marker,
                            content: instance.$el,
                            placement: 'top',
                            border: false,
                            shadow: false,
                            pointer: false,
                            showCloseButton: false,
                            maxWidth: 447,
                            backgroundColor: 'transparent',
                            offset: {
                                left: '-1px',
                                top: '-52px'
                            },
                            edgeOffset: that.getMapPadding(),
                            callbacks: {
                                beforeClose: function () {
                                    that.selectStation(null);
                                    return false; //we don't want the actual close to fire here, instead we "unselect" the active station (which then calls setActive(null), which in turn closes/destroys the infowindow)
                                }
                            }
                        });

                        //make sure, the icon is still "selected"
                        marker.setIcon(station.markerselectedurl);

                        //now open it
                        that.infowindow.open();
                    });
                }
            },
            refreshMarkers() {
                const { Marker } = this.google.maps;
                const gMap = this.map;

                const markerFactory = station => {

                    let mark = new Marker({
                        position: { lat: +station.latitude, lng: +station.longitude },
                        icon: station == this.selectedStation ? station.markerselectedurl : station.markerurl,
                        title: textarea.html(station.name + ', ' + station.addressnohtml).text(), //this unescapes html entities
                        map: gMap
                    });
                    //we associate the stationId directly with the mark, so we can use it in the setActive method to find the marker again
                    mark.stationId = station.id;
                    mark.markerInactiveUrl = station.markerurl;

                    mark.addListener('click', () => {
                        this.selectStation(station);
                    });
                    mark.addListener('mouseover', () => {
                        if (this.infowindow == null || this.infowindow._marker != mark)
                            mark.setIcon(station.markerselectedurl);
                    });
                    mark.addListener('mouseout', () => {
                        if (this.infowindow == null || this.infowindow._marker != mark)
                            mark.setIcon(station.markerurl);
                    });
                    return mark;
                };

                const createMarkers = R.map(markerFactory);

                if (this.markerCluster != null) {
                    this.markerCluster.reset();
                    this.markerCluster.clearMarkers();
                    this.markerCluster.addMarkers(createMarkers(this.filteredStations));
                } else {
                    this.markerCluster = new MarkerClusterer({
                        map: this.map,
                        markers: createMarkers(this.filteredStations),
                        renderer: new MigrolClusterRenderer(window.TS_CONFIG.markerclusterImage),
                        algorithm: new SuperClusterAlgorithm({
                            maxZoom: clusterizeZoomLevelThreshold,
                            radius: 200,
                            minPoints: 5
                        })
                    });
                }
            },
            ensureAtLeastOneVisibleMarker() {
                const mapCenter = this.map.getCenter();
                const mapCenterLat = mapCenter.lat();
                const mapCenterLng = mapCenter.lng();
                const markers = this.markerCluster.markers;
                const mapBounds = this.getPaddedBounds();
                let closestMarkerPosition = null;
                let closestDistance = 9999999999999;
                let atLeastOneMarkerVisible = false;

                for (var i = 0; i < markers.length; i++) {
                    const pos = markers[i].getPosition();
                    if (mapBounds && mapBounds.contains(pos)) {
                        atLeastOneMarkerVisible = true;
                        break;
                    }
                    const distance = Utils.calculateDistance(mapCenterLat, mapCenterLng, pos.lat(), pos.lng());
                    if (distance < closestDistance) {
                        closestMarkerPosition = pos;
                        closestDistance = distance;
                    }
                }
                if (!atLeastOneMarkerVisible && closestMarkerPosition != null && mapCenter != null) {
                    let newBounds = new this.google.maps.LatLngBounds();
                    newBounds.extend(mapCenter);
                    newBounds.extend(closestMarkerPosition);
                    this.map.fitBounds(newBounds, this.getMapPadding());
                }
            }
        },
        components: {
            StationInfoWindow
        }
    };
</script>